import "./landing.scss";
import Cookies from "js-cookie";

$(function () {
	// menu
	const $pageSide     = $('[data-js="page__side"]'),
		  $pageFade     = $('[data-js="page__fade"]'),
		  $buttonCookie = $('[data-js="cookie-close"]'),
		  $cookieBar    = $('[data-js="cookie-bar"]'),
		  $cookie       = Cookies.set('cookieBar');
	
	// toggle ready modifier due strange issue with wrong initial state of side panel		  
	$pageSide.addClass("page__fade--ready");

	$('[data-js~="burger"]').click(function () {
		$pageSide.addClass("page__side-landing--visible");
		$pageFade.addClass("page__fade--active");
		$.fn.fullpage.setAllowScrolling(false);
	});

	$pageFade.click(function () {
		$pageSide.removeClass("page__side-landing--visible");
		$pageFade.removeClass("page__fade--active");
		$.fn.fullpage.setAllowScrolling(true);
	});

	setTimeout(function () {
		if (!$cookie) {
			$cookieBar.addClass("cookie-bar--visible");
		}
	}, 3000);

	$buttonCookie.on('click', function () {
		Cookies.set('cookieBar', true, {
			expires: 1000000
		});
		$cookieBar.removeClass("cookie-bar--visible");
	});
});



// WEBPACK FOOTER //
// ./static/components/landing/Landing.js